import { Module } from 'vuex'

const voiceModule: Module<any, any> = {
  namespaced: true,

  state: () => ({
    activeVoiceTag: '',
  }),

  mutations: {
    setActiveVoiceTag(state, activeVoiceTag) {
      state.activeVoiceTag = activeVoiceTag
    },
  },
  actions: {
    setActiveVoiceTag({ commit }, activeVoiceTag) {
      commit('setActiveVoiceTag', activeVoiceTag)
    },
  },
  getters: {
    activeVoiceTag(state) {
      return state.activeVoiceTag
    },
  },
}

export default voiceModule
